import { render, staticRenderFns } from "./MoveWindow.vue?vue&type=template&id=64ea82b2&scoped=true"
import script from "./MoveWindow.vue?vue&type=script&lang=js"
export * from "./MoveWindow.vue?vue&type=script&lang=js"
import style0 from "./MoveWindow.vue?vue&type=style&index=0&id=64ea82b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea82b2",
  null
  
)

export default component.exports